import { connect } from 'react-redux'
import View from './LanguageSelector'
import { changeLanguage } from '../../../../../../store/modules/router'
import { compose } from 'redux'

const mapStateToProps = state => ({
  locale: state.router.locale,
})

const mapDispatchToProps = dispatch => ({
  changeLanguage: compose(dispatch, changeLanguage),
})

const LanguageSelector = connect(mapStateToProps, mapDispatchToProps)(View)

export default LanguageSelector
